import { MakePayment } from "container/OnBoarding/MakePayment";
import { useNavigate } from "react-router-dom";

const MakePaymentForUnPaid = () => {
  const navigate = useNavigate();
  const onPressBack = () => {
    navigate("/dashboard/memberDashboard");
  };
  return (
    <MakePayment isCustom={true} forUnPaid={true} onPressBack={onPressBack} />
  );
};
export default MakePaymentForUnPaid;
